import React, { useEffect, useRef, useState } from "react";
import WalletModal from "./WalletModal";

export default function ProfileMenu({ onNavigateProfile, onLogout }) {
  const [open, setOpen] = useState(false);
  const [showWallet, setShowWallet] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} className="relative shrink-0">
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Account menu"
        className="w-9 h-9 rounded-full flex items-center justify-center transition-colors"
        style={{ backgroundColor: open ? "var(--bg-hover)" : "var(--bg-card)", border: "1px solid var(--border-color)" }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--text-secondary)" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-40 rounded-lg overflow-hidden z-50"
          style={{ backgroundColor: "var(--bg-card)", border: "1px solid var(--border-color)" }}
        >
          <button
            onClick={() => { onNavigateProfile(); setOpen(false); }}
            className="w-full text-left px-3 py-2.5 text-sm transition-colors"
            style={{ color: "var(--text-primary)" }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "var(--bg-hover)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
          >
            Profile
          </button>
          <button
            onClick={() => { setShowWallet(true); setOpen(false); }}
            className="w-full text-left px-3 py-2.5 text-sm transition-colors"
            style={{ color: "var(--text-primary)" }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "var(--bg-hover)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
          >
            Wallet
          </button>
          <button
            onClick={() => { onLogout(); setOpen(false); }}
            className="w-full text-left px-3 py-2.5 text-sm transition-colors"
            style={{ color: "var(--loss-red)" }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "var(--bg-hover)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
          >
            Log out
          </button>
        </div>
      )}

      <WalletModal open={showWallet} onClose={() => setShowWallet(false)} onSuccess={() => {}} />
    </div>
  );
}
